export default "__VITE_ASSET__BE7ke2yk__"